import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";

import { LanguageContext } from "../utils/contexts";
import { localize } from "../utils/translator";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Container, Divider, Grid, Typography } from "@material-ui/core";
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';

import CenteredContent from "../components/CenteredContent";
import CustomSelect from "../components/CustomSelect";
import CustomSlider from "../components/CustomSlider";

const useStyles = makeStyles((theme) => ({
  button: {
    fontWeight: "bold",
    backgroundColor: "#ffc26c",
    color: "#504538",
    textDecoration: "none",
    height: "50px",
    width: 200
  },
  toggleButtonGroup: {
    paddingLeft: 100
  }
}));

const style = {
  background: '#EEE',
  borderRadius: 3,
  border: "1px solid black",
  color: 'black',
  height: 35,
  width: 150,
  padding: '0 30px',
  margin: 10,
};

const styleSelected = {
  background: 'linear-gradient(45deg, #FFAE53 5%, #FFC26C 50%)',
  borderRadius: 3,
  border: 0,
  color: 'black',
  height: 35,
  width: 150,
  padding: '0 30px',
  boxShadow: '0 1px 3px 2px rgba(255, 105, 135, .3)',
  margin: 10,
}

const FormPage = (props) => {
  const { language } = useContext(LanguageContext);
  const classes = useStyles();

  const [campusLife, setCampusLife] = useState(localize("levels.low", language));
  const handleCampusLife = (event, newCampusLife) => {
    if (newCampusLife !== null) {
      setCampusLife(newCampusLife);
    }
  };

  const [alumni, setAlumni] = useState(localize("levels.low", language));
  const handleAlumni = (event, newAlumni) => {
    if (newAlumni !== null) {
      setAlumni(newAlumni);
    }
  };

  const [tuition, setTuition] = useState(localize("levels.low", language));
  const handleTuition = (event, newTuition) => {
    if (newTuition !== null) {
      setTuition(newTuition);
    }
  };


  return (
    <Container component="main" maxWidth="xl">
      <CenteredContent title="form.title" margin={3}>
        <div style={{ paddingLeft: 180 }}>
          <CustomSelect
            name="form.levelName"
            label="form.levelLabel"
            options="form.levelOptions"
          />

          <CustomSelect
            name="form.domainName"
            label="form.domainLabel"
            options="form.domainOptions"
          />

          <CustomSelect
            name="form.specialityName"
            label="form.specialityLabel"
            options="form.specialityOptions"
          />
        </div>

        <Divider style={{ margin: "20px 0" }} />

        <Typography style={{ paddingBottom: 10, }}>{localize("form.life", language)}</Typography>
        <ToggleButtonGroup
          exclusive
          value={campusLife}
          onChange={handleCampusLife}
          className={classes.toggleButtonGroup}
        >
          <ToggleButton
            style={campusLife === localize("levels.low", language) ? styleSelected : style}
            value={localize("levels.low", language)}
          >
            <Typography style={{ fontSize: 13 }}>{localize("levels.low", language)}</Typography>
          </ToggleButton>
          <ToggleButton
            style={campusLife === localize("levels.medium", language) ? styleSelected : style}
            value={localize("levels.medium", language)}>
            <Typography style={{ fontSize: 13 }}>{localize("levels.medium", language)}</Typography>
          </ToggleButton>
          <ToggleButton
            style={campusLife === localize("levels.high", language) ? styleSelected : style}
            value={localize("levels.high", language)}>
            <Typography style={{ fontSize: 13 }}>{localize("levels.high", language)}</Typography>
          </ToggleButton>
        </ToggleButtonGroup>
        <Typography style={{ paddingBottom: 10, paddingTop: 40 }}>{localize("form.alumni", language)}</Typography>
        <ToggleButtonGroup
          exclusive
          value={alumni}
          onChange={handleAlumni}
          className={classes.toggleButtonGroup}
        >
          <ToggleButton
            style={alumni === localize("levels.low", language) ? styleSelected : style}
            value={localize("levels.low", language)}
          >
            <Typography style={{ fontSize: 13 }}>{localize("levels.low", language)}</Typography>
          </ToggleButton>
          <ToggleButton
            style={alumni === localize("levels.medium", language) ? styleSelected : style}
            value={localize("levels.medium", language)}>
            <Typography style={{ fontSize: 13 }}>{localize("levels.medium", language)}</Typography>
          </ToggleButton>
          <ToggleButton
            style={alumni === localize("levels.high", language) ? styleSelected : style}
            value={localize("levels.high", language)}>
            <Typography style={{ fontSize: 13 }}>{localize("levels.high", language)}</Typography>
          </ToggleButton>
        </ToggleButtonGroup>
        <Typography style={{ paddingBottom: 10, paddingTop: 40 }}>{localize("form.money", language)}</Typography>
        <ToggleButtonGroup
          exclusive
          value={tuition}
          onChange={handleTuition}
          className={classes.toggleButtonGroup}
        >
          <ToggleButton
            style={tuition === localize("levels.low", language) ? styleSelected : style}
            value={localize("levels.low", language)}
          >
            <Typography style={{ fontSize: 13 }}>{localize("levels.low", language)}</Typography>
          </ToggleButton>
          <ToggleButton
            style={tuition === localize("levels.medium", language) ? styleSelected : style}
            value={localize("levels.medium", language)}>
            <Typography style={{ fontSize: 13 }}>{localize("levels.medium", language)}</Typography>
          </ToggleButton>
          <ToggleButton
            style={tuition === localize("levels.high", language) ? styleSelected : style}
            value={localize("levels.high", language)}>
            <Typography style={{ fontSize: 13 }}>{localize("levels.high", language)}</Typography>
          </ToggleButton>
        </ToggleButtonGroup>

        <Grid container>
          <Grid item xs={12} style={{ textAlign: "center", marginTop: "40px" }}>
            <Link to={"/display"} style={{ textDecoration: "none" }}>
              <Button variant="contained" className={classes.button}>
                {localize("form.button", language)}
              </Button>
            </Link>
          </Grid>
        </Grid>
      </CenteredContent>
    </Container>
  );
};

export default FormPage;
